export default __webpack_public_path__ + "static/001-223ed37cb683a5fe88ae76fe6ba55a05.png";